/*
 * 2026 产品卡选项联动。
 *
 * 规则来源：需求分析 7.3（R-18 ~ R-23）。
 *   - 有 Style 时，颜色集合收敛为该 Style 下存在可用变体的颜色。
 *   - 切换 Style 后若当前颜色不在该 Style 内，自动选中该 Style 的第一个颜色（按颜色值原始顺序）。
 *   - 不允许因「别的 Style 没有这个颜色」而禁用 Style 切换。
 *   - 无 Style 时展示全部颜色，不做联动。
 */
(function () {
  'use strict';

  /*
   * 促销信息条跑马灯的恒定速度（px/s）。
   * 契约：文案无论多长、卡片多宽，滚动速度都是这一个值（用户 2026-09-23 裁决）。
   * 调整播放快慢只改这里；不要在下面再引入"最小/最大时长"或取整。
   */

  function parseJSON(node, fallback) {
    if (!node) return fallback;
    try {
      var value = JSON.parse(node.textContent);
      return value == null ? fallback : value;
    } catch (error) {
      return fallback;
    }
  }

  function sameValue(a, b) {
    return String(a == null ? '' : a) === String(b == null ? '' : b);
  }

  /* ============================================================
   * 活动信息配图「问号」说明（2026-11-02 用户）
   *   · PC：hover 整张配图 → 气泡（顶部尖尖对准问号，Figma 7013:4162）
   *   · M ：点击配图 → 弹窗（Figma 6500:44600），点遮罩/关闭/Esc 收起
   *   · 文案是元对象富文本（extra_info_image_msg），样式由配置决定，这里只放内容
   *   · 气泡/弹窗挂在 body 上：卡片是 overflow: clip，放卡里会被裁掉
   * ============================================================ */

  function infoMsgHtml(wrap) {
    var tpl = wrap && wrap.querySelector('[data-vl-product-card-info-msg-src]');
    return tpl ? tpl.innerHTML : '';
  }

  /* 把配图 wrap 的问号与文案同步到最新变体的数据（变体切换时调用） */
  function syncInfoMsg(wrap, msg, cardRoot) {
    var btn = wrap.querySelector('[data-vl-product-card-info-msg]');
    var src = wrap.querySelector('[data-vl-product-card-info-msg-src]');
    var hit = wrap.querySelector('[data-vl-product-card-info-msg-hit]');
    if (!msg) {
      if (btn) btn.remove();
      if (src) src.remove();
      if (hit) hit.remove();
      wrap.removeAttribute('data-vl-product-card-info-msg-wrap');
      return;
    }
    if (!hit) {
      /* 点击热区：铺满整条配图，保证点击不会被卡片链接抢走（与 Liquid 输出的那份一致） */
      hit = document.createElement('span');
      hit.className = 'vl-product-card__info-msg-hit';
      hit.setAttribute('data-vl-product-card-info-msg-hit', '');
      hit.setAttribute('aria-hidden', 'true');
      wrap.appendChild(hit);
    }
    if (!btn) {
      btn = document.createElement('span');
      btn.className = 'vl-product-card__info-msg';
      btn.setAttribute('data-vl-product-card-info-msg', '');
      btn.setAttribute('aria-hidden', 'true');
      var icon = document.createElement('img');
      icon.alt = '';
      icon.width = 9;
      icon.height = 9;
      icon.loading = 'lazy';
      icon.src = (cardRoot && cardRoot.dataset && cardRoot.dataset.vlInfoQIcon) || '';
      btn.appendChild(icon);
      wrap.appendChild(btn);
    }
    if (!src) {
      src = document.createElement('template');
      src.setAttribute('data-vl-product-card-info-msg-src', '');
      wrap.appendChild(src);
    }
    src.innerHTML = msg;
    wrap.setAttribute('data-vl-product-card-info-msg-wrap', '');
  }

  var infoTip = null;
  var infoModal = null;

  function ensureInfoTip() {
    if (infoTip && infoTip.isConnected) return infoTip;
    infoTip = document.createElement('div');
    infoTip.className = 'vl-product-card__info-tip';
    infoTip.setAttribute('role', 'tooltip');
    document.body.appendChild(infoTip);
    return infoTip;
  }

  function showInfoTip(btn, wrap) {
    var html = infoMsgHtml(wrap);
    if (!html) return;
    var tip = ensureInfoTip();
    tip.innerHTML = html;
    tip.classList.add('is-open');
    /* 先量尺寸再定位（is-open 只影响 opacity/visibility，不影响布局） */
    var size = tip.getBoundingClientRect();
    var anchor = btn.getBoundingClientRect();
    var gutter = 8;
    var centerX = anchor.left + anchor.width / 2;
    var left = Math.min(Math.max(gutter, centerX - size.width / 2), window.innerWidth - size.width - gutter);
    var top = anchor.bottom + 12;
    tip.style.left = Math.round(left) + 'px';
    tip.style.top = Math.round(top) + 'px';
    tip.style.setProperty('--vl-info-tip-arrow-x', Math.round(centerX - left) + 'px');
  }

  function hideInfoTip() {
    if (infoTip) infoTip.classList.remove('is-open');
  }

  function ensureInfoModal() {
    if (infoModal && infoModal.isConnected) return infoModal;
    infoModal = document.createElement('div');
    infoModal.className = 'vl-product-card__info-modal';
    infoModal.innerHTML =
      '<div class="vl-product-card__info-modal-backdrop" data-vl-info-modal-close></div>' +
      '<div class="vl-product-card__info-modal-box" role="dialog" aria-modal="true">' +
      '<button type="button" class="vl-product-card__info-modal-close" data-vl-info-modal-close aria-label="Close">&times;</button>' +
      '<div class="vl-product-card__info-modal-body" data-vl-info-modal-body></div>' +
      '</div>';
    document.body.appendChild(infoModal);
    return infoModal;
  }

  function openInfoModal(wrap) {
    var html = infoMsgHtml(wrap);
    if (!html) return;
    var modal = ensureInfoModal();
    modal.querySelector('[data-vl-info-modal-body]').innerHTML = html;
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeInfoModal() {
    if (!infoModal) return;
    infoModal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function isTouchUi() {
    return window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;
  }

  document.addEventListener('mouseover', function (event) {
    if (isTouchUi()) return;
    var wrap = event.target.closest && event.target.closest('[data-vl-product-card-info-msg-wrap]');
    if (!wrap) return;
    var btn = wrap.querySelector('[data-vl-product-card-info-msg]');
    if (btn) showInfoTip(btn, wrap);
  });

  document.addEventListener('mouseout', function (event) {
    var wrap = event.target.closest && event.target.closest('[data-vl-product-card-info-msg-wrap]');
    if (!wrap) return;
    /* 只在真正离开整张配图时收起（在 wrap 内部移动不收起） */
    if (event.relatedTarget && wrap.contains(event.relatedTarget)) return;
    hideInfoTip();
  });

  /* 关闭按钮 / 遮罩：冒泡阶段处理即可 */
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-vl-info-modal-close]')) {
      closeInfoModal();
    }
  });

  /*
   * 点击整张配图 → 弹窗（M 端）。
   * 2026-11-02 用户：真机上点这条会触发产品卡跳转 ⇒ 拦截必须**最靠前 + 最全**：
   *   ① 监听挂在 **window 的捕获阶段**（比 document/元素级任何 capture 都早，主题脚本抢不到）；
   *   ② `click` 里同时 `preventDefault()`（挡 <a> 默认跳转）与 `stopPropagation()` / `stopImmediatePropagation()`；
   *   ③ `pointerdown / pointerup / touchstart / touchend` 也一并 stop（有些卡片是"按下即跳"）；
   *   ④ 判定不再依赖 `hover/pointer` 媒体查询（桌面触屏/平板/微信内置浏览器会判错），
   *      改为"点击时指针是触摸 或 设备没有 hover" ⇒ 一律按 M 端弹窗处理。
   */
  function wrapFromEvent(event) {
    var target = event.target;
    if (!target || !target.closest) return null;
    return target.closest('[data-vl-product-card-info-msg-wrap]');
  }

  /*
   * 坐标兜底（2026-11-02 用户）：卡片里可能有一层比图更大的 <a>（媒体区链接 / 整卡链接）盖住这条配图，
   * 这时事件 target 是那个 <a>，`closest` 找不到 wrap —— 但用户点的确实是配图。
   * 所以再按**点击坐标**判断落在了哪条配图内（不依赖 DOM 层级、也不改图片任何样式）。
   */
  function wrapAtPoint(x, y) {
    if (typeof x !== 'number' || typeof y !== 'number') return null;
    var wraps = document.querySelectorAll('[data-vl-product-card-info-msg-wrap]');
    for (var i = 0; i < wraps.length; i += 1) {
      var rect = wraps[i].getBoundingClientRect();
      if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) return wraps[i];
    }
    return null;
  }

  function inModal(target) {
    return !!(target && target.closest && target.closest('.vl-product-card__info-modal'));
  }

  function resolveWrap(event) {
    if (inModal(event.target)) return null;
    var wrap = wrapFromEvent(event);
    if (wrap) return wrap;
    if (!shouldUseModal(event)) return null;
    return wrapAtPoint(event.clientX, event.clientY);
  }

  function shouldUseModal(event) {
    if (event && (event.pointerType === 'touch' || event.pointerType === 'pen')) return true;
    if (event && event.sourceCapabilities && event.sourceCapabilities.firesTouchEvents) return true;
    return isTouchUi();
  }

  function swallow(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  ['pointerdown', 'pointerup', 'touchstart', 'touchend'].forEach(function (type) {
    window.addEventListener(type, function (event) {
      var wrap = resolveWrap(event);
      if (!wrap) return;
      /* 只 stop（不 preventDefault，避免影响长按/滚动），让卡片的按下跳转拿不到事件 */
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }, true);
  });

  window.addEventListener('click', function (event) {
    var wrap = resolveWrap(event);
    if (!wrap) return;
    swallow(event);
    hideInfoTip();
    openInfoModal(wrap);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeInfoModal();
      hideInfoTip();
    }
  });

  window.addEventListener('scroll', hideInfoTip, { passive: true });
  window.addEventListener('resize', hideInfoTip);

  function VLCard(root) {
    this.root = root;
    this.config = parseJSON(root.querySelector('[data-vl-product-card-config]'), {});
    this.variants = parseJSON(root.querySelector('[data-vl-product-card-variants]'), []);
    this.tags = parseJSON(root.querySelector('[data-vl-product-card-tags]'), []);
    this.infoData = parseJSON(root.querySelector('[data-vl-product-card-info-data]'), {
      static: true,
      byVariant: []
    });
    this.inventoryData = parseJSON(root.querySelector('[data-vl-product-card-inventory-data]'), []);
    this.giftData = parseJSON(root.querySelector('[data-vl-product-card-gifts]'), {
      static: true,
      byVariant: []
    });
    this.styleIndex = Number(this.config.styleIndex);
    this.colorIndex = Number(this.config.colorIndex);
    this.colors = Array.isArray(this.config.colors) ? this.config.colors : [];
    this.hasStyle = this.styleIndex >= 0 && !!root.querySelector('[data-vl-product-card-style]');
    /*
     * 颜色选择器是否实际启用（2026-10-29 统一卡改造）。
     * 之前只看 `colorIndex >= 0`（= 产品有 Color 选项），但开关关闭后 Liquid 不渲染色块，
     * JS 仍会把 selected.color 设成第一个颜色并据此过滤变体 ⇒ 切 Style 时选不到变体。
     * 因此以 Liquid 输出的 `data-has-color` 为准（关闭时不按颜色过滤）；
     * 老缓存 HTML 没有该属性时回退到旧判断，避免行为退化。
     */
    this.hasColor = root.hasAttribute('data-has-color')
      ? root.getAttribute('data-has-color') === 'true'
      : this.colorIndex >= 0;
    this.styleSelect = root.querySelector('[data-vl-product-card-style]');
    this.colorInputs = Array.prototype.slice.call(root.querySelectorAll('[data-vl-product-card-color]'));
    this.selected = this.readSelectedFromDOM();
  }

  VLCard.prototype.readSelectedFromDOM = function () {
    var selected = {};
    if (this.hasStyle && this.styleSelect) selected.style = this.styleSelect.value;
    var checked = this.root.querySelector('[data-vl-product-card-color]:checked');
    if (checked && (!this.hasStyle || this.colorAvailableForStyle(checked.value, selected.style))) {
      selected.color = checked.value;
    }
    if (this.hasColor && !selected.color) {
      selected.color = this.firstColorOfStyle(selected.style) || this.colors[0];
    }
    return selected;
  };

  /*
   * 某颜色在当前 Style 下**是否存在**变体（2026-09-28 用户裁决：颜色切换不受库存影响）。
   * 刻意不判 `variant.available`：缺货/不可售的颜色同样可点（切换后展示该变体的价格/图/链接）；
   * 只有"该颜色在当前 Style 下没有任何变体"（组合不存在，或该变体被 `velotric.hide_variant` 隐藏）才不可点。
   */
  VLCard.prototype.colorExistsForStyle = function (color, style) {
    if (!this.hasColor) return false;
    return this.variants.some(function (variant) {
      if (!sameValue(variant.options[this.colorIndex], color)) return false;
      if (this.hasStyle && !sameValue(variant.options[this.styleIndex], style)) return false;
      return true;
    }, this);
  };

  /* 某颜色在「任意 Style」下是否存在（用于无 Style 场景与兜底）——同样不看库存 */
  VLCard.prototype.colorExists = function (color) {
    if (!this.hasColor) return false;
    return this.variants.some(function (variant) {
      return sameValue(variant.options[this.colorIndex], color);
    }, this);
  };

  /*
   * 某颜色在当前 Style 下是否**有可售变体**（2026-10-20 方案 B）。
   * 与 colorExistsForStyle 的区别：只看 `available === true` 的变体。
   */
  VLCard.prototype.colorAvailableForStyle = function (color, style) {
    if (!this.hasColor) return false;
    return this.variants.some(function (variant) {
      if (!variant.available) return false;
      if (!sameValue(variant.options[this.colorIndex], color)) return false;
      if (this.hasStyle && !sameValue(variant.options[this.styleIndex], style)) return false;
      return true;
    }, this);
  };

  /* 某颜色在任意 Style 下是否至少有一个可售变体（无 Style 场景与兜底） */
  VLCard.prototype.colorAvailable = function (color) {
    if (!this.hasColor) return false;
    return this.variants.some(function (variant) {
      return variant.available && sameValue(variant.options[this.colorIndex], color);
    }, this);
  };

  /*
   * 该颜色存在的第一个 Style（按 Style 下拉的原始顺序）——2026-09-28 用户裁决：
   * 颜色切换要"能点就有反应"，因此点击一个只在别的 Style 下存在的颜色时，
   * 自动把 Style 切过去（原规格里的"Style+Color 双选项联动"）。
   */
  VLCard.prototype.firstStyleOfColor = function (color) {
    if (!this.hasColor) return null;
    if (!this.hasStyle || !this.styleSelect) return null;
    var styles = Array.prototype.map.call(this.styleSelect.options, function (option) {
      return option.value;
    });
    for (var i = 0; i < styles.length; i += 1) {
      if (this.colorAvailableForStyle(color, styles[i])) return styles[i];
    }
    for (var j = 0; j < styles.length; j += 1) {
      if (this.colorExistsForStyle(color, styles[j])) return styles[j];
    }
    return null;
  };

  /*
   * 组代表变体（2026-10-29 用户）：图片/价格与库存/标签必须同源。
   * 优先级：① 组内**有库存信息**的变体（其中可售优先）→ ② 可售 → ③ 组内第一个。
   * 与 Liquid 侧 `prefer_inventory`（唯一库存组合默认选中）口径一致。
   */
  VLCard.prototype.findVariant = function (selected) {
    var self = this;
    var group = this.variants.filter(function (variant) {
      if (self.hasStyle && !sameValue(variant.options[self.styleIndex], selected.style)) return false;
      if (self.hasColor && selected.color && !sameValue(variant.options[self.colorIndex], selected.color)) return false;
      return true;
    });
    if (!group.length) return null;
    var withInventory = group.filter(function (v) { return v.inventory === true; });
    var pool = withInventory.length ? withInventory : group;
    return pool.filter(function (v) { return v.available; })[0] || pool[0];
  };

  /*
   * 当前选择器对应的**变体组**（2026-10-29 用户）。
   * 产品卡最多只有 Color + Style 两个选项，选完并不一定落到唯一变体：
   *   例：只有 Color 没有 Style 时，选中某个颜色 = 该颜色下的一整组变体。
   * 标签 / 赠品 / 信息条都必须按这个"组"判断，而不是碰巧被选中的单个变体。
   */
  VLCard.prototype.groupVariants = function (selected) {
    var self = this;
    return this.variants.filter(function (variant) {
      if (self.hasStyle && !sameValue(variant.options[self.styleIndex], selected.style)) return false;
      if (self.hasColor && selected.color && !sameValue(variant.options[self.colorIndex], selected.color)) return false;
      return true;
    });
  };

  /*
   * 从逐变体数据（tags / gifts / info）里按"组"取一条：
   *   ① 当前展示变体自己有值 → 用它（保证「Save $X」的金额与价格/赠品同源）；
   *   ② 否则回退到组内第一个有值的变体（用户口径：组内包含该变体，就要切换过去）。
   * key 为数据字段名（'tag' / 'gift' / 'info'）。找不到返回 null。
   */
  VLCard.prototype.pickGroupEntry = function (list, key, preferredId) {
    if (!Array.isArray(list) || !list.length) return null;
    var groupIds = {};
    this.groupVariants(this.selected).forEach(function (v) {
      groupIds[String(v.id)] = true;
    });
    var preferred = null;
    var first = null;
    for (var i = 0; i < list.length; i += 1) {
      var entry = list[i];
      if (!entry || !entry[key]) continue;
      if (!groupIds[String(entry.id)]) continue;
      if (preferredId != null && String(entry.id) === String(preferredId)) {
        preferred = entry;
        break;
      }
      if (!first) first = entry;
    }
    return preferred || first;
  };

  VLCard.prototype.setupInfoMarquee = function () {
    if (window.VLInfoMarquee) window.VLInfoMarquee.setup(this.root);
  };

  VLCard.prototype.render = function () {
    var variant = this.findVariant(this.selected);
    if (!variant) return;

    var image = this.root.querySelector('[data-vl-product-card-image]');
    if (image) {
      if (variant.image) {
        image.hidden = false;
        image.src = variant.image;
        /* 变体图切换后原 srcset 的宽度描述已不匹配，直接移除，避免浏览器选到旧图 */
        image.removeAttribute('srcset');
        this.clearImageMissing();
      } else {
        /*
         * 用户 2026-09-23 裁决：该情况不做兜底。
         * 变体没有 featured_image 时不得沿用上一张图（那会把后台配置缺口藏起来），
         * 而是清空画廊并显式暴露，便于回后台补齐图片后自然恢复。
         */
        image.hidden = true;
        image.removeAttribute('src');
        image.removeAttribute('srcset');
        this.reportImageMissing(variant.id);
      }
    }

    var price = this.root.querySelector('[data-vl-product-card-price]');
    if (price) price.textContent = variant.priceMoney;

    var compare = this.root.querySelector('[data-vl-product-card-compare-price]');
    if (compare) {
      if (variant.compareAtPriceMoney) {
        compare.textContent = variant.compareAtPriceMoney;
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }
    }

    var cta = this.root.querySelector('[data-vl-product-card-cta]');
    if (cta && variant.url) cta.setAttribute('href', variant.url);

    /* 画廊覆盖链接与标题链接：随变体切换同步目标 PDP（含所选变体参数） */
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-vl-product-card-url]'), function (link) {
      if (variant.url) link.setAttribute('href', variant.url);
    });

    /* Affirm 分期金额随变体变化：更新 data-amount（单位：分），再通知 SDK 重绘 */
    var affirmAmount = this.root.querySelector('[data-vl-product-card-affirm] .affirm-as-low-as');
    if (affirmAmount) {
      affirmAmount.setAttribute('data-amount', String(variant.price));
      if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
        window.affirm.ui.refresh();
      }
    }

    this.renderTag(variant.id);
    this.renderInventory(variant.id);
    this.renderGift(variant.id);
    this.renderInfo(variant.id);
    this.syncColorStates();
    this.syncOptionPills();
    this.setupInfoMarquee();
  };

  /*
   * 新版胶囊选择器（option_selector: 'pills'，2026-11-03）
   * · 胶囊按钮只是「外观 + 点击目标」，真源仍是被视觉隐藏的原生 select
   *   （[data-vl-product-card-style]）—— 变体联动、色块收敛全走旧逻辑，零分叉；
   * · 这里只做三件事：① 把 select 的值同步成选中态；② 把选中项滚到「尽量居中」；
   *   ③ 绑定点击 / 键盘 / 拖拽横向滚动。
   */
  function scrollOptionIntoView(track, optionEl, smooth) {
    if (!track || !optionEl) return;
    var max = track.scrollWidth - track.clientWidth;
    if (max <= 0) return;
    var trackRect = track.getBoundingClientRect();
    var optionRect = optionEl.getBoundingClientRect();
    /* 选中项中心对准可视区中心；超出首/尾时由 clamp 贴边（用户 2026-11-03 口径） */
    var target = track.scrollLeft
      + (optionRect.left - trackRect.left)
      - (track.clientWidth - optionRect.width) / 2;
    target = Math.max(0, Math.min(target, max));
    if (Math.abs(target - track.scrollLeft) < 1) return;
    if (typeof track.scrollTo === 'function') {
      track.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
    } else {
      track.scrollLeft = target;
    }
  }

  VLCard.prototype.syncOptionPills = function () {
    var self = this;
    var smooth = this.optionScrollSmooth === true;
    this.optionScrollSmooth = false;
    Array.prototype.forEach.call(
      this.root.querySelectorAll('[data-vl-product-card-options]'),
      function (row) {
        /* AB 模式下胶囊行不自带 select，回落到卡片媒体区的同一个 select */
        var select = row.querySelector('[data-vl-product-card-style]')
          || self.root.querySelector('[data-vl-product-card-style]');
        var track = row.querySelector('[data-vl-options-track]');
        if (!select || !track) return;
        var selected = null;
        Array.prototype.forEach.call(track.querySelectorAll('[data-vl-option]'), function (btn) {
          var on = sameValue(btn.getAttribute('data-vl-option-value'), select.value);
          btn.classList.toggle('is-selected', on);
          btn.setAttribute('aria-checked', on ? 'true' : 'false');
          btn.tabIndex = on ? 0 : -1;
          if (on) selected = btn;
        });
        if (selected) scrollOptionIntoView(track, selected, smooth);
      }
    );
  };

  VLCard.prototype.bindOptionPills = function () {
    var self = this;
    Array.prototype.forEach.call(
      this.root.querySelectorAll('[data-vl-product-card-options]'),
      function (row) {
        var select = row.querySelector('[data-vl-product-card-style]')
          || self.root.querySelector('[data-vl-product-card-style]');
        var track = row.querySelector('[data-vl-options-track]');
        if (!select || !track || track.dataset.vlOptionsBound === 'true') return;
        track.dataset.vlOptionsBound = 'true';

        function choose(value) {
          if (!value || sameValue(select.value, value)) return;
          select.value = value;
          self.optionScrollSmooth = true;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        track.addEventListener('click', function (event) {
          var btn = event.target.closest('[data-vl-option]');
          if (!btn) return;
          /* 拖拽结束后的那次 click 不当作选中 */
          if (track.dataset.vlDragged === 'true') return;
          choose(btn.getAttribute('data-vl-option-value'));
        });

        track.addEventListener('keydown', function (event) {
          var key = event.key;
          if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') return;
          var buttons = Array.prototype.slice.call(track.querySelectorAll('[data-vl-option]'));
          if (!buttons.length) return;
          var index = buttons.indexOf(document.activeElement);
          if (index < 0) index = 0;
          var next = index;
          if (key === 'ArrowLeft') next = Math.max(0, index - 1);
          if (key === 'ArrowRight') next = Math.min(buttons.length - 1, index + 1);
          if (key === 'Home') next = 0;
          if (key === 'End') next = buttons.length - 1;
          event.preventDefault();
          buttons[next].focus();
          choose(buttons[next].getAttribute('data-vl-option-value'));
        });

        /* 鼠标拖拽横向滚动（触屏走原生滚动；拖拽后抑制一次 click） */
        var dragging = false;
        var startX = 0;
        var startLeft = 0;
        var moved = false;

        track.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          dragging = true;
          moved = false;
          startX = event.clientX;
          startLeft = track.scrollLeft;
          track.classList.add('is-dragging');
        });

        window.addEventListener('pointermove', function (event) {
          if (!dragging) return;
          var dx = event.clientX - startX;
          if (Math.abs(dx) > 4) moved = true;
          if (moved) track.scrollLeft = startLeft - dx;
        });

        window.addEventListener('pointerup', function () {
          if (!dragging) return;
          dragging = false;
          track.classList.remove('is-dragging');
          if (moved) {
            track.dataset.vlDragged = 'true';
            window.setTimeout(function () {
              delete track.dataset.vlDragged;
            }, 0);
          }
        });

        window.addEventListener('pointercancel', function () {
          if (!dragging) return;
          dragging = false;
          track.classList.remove('is-dragging');
        });

        window.addEventListener('resize', function () {
          self.syncOptionPills();
        });
      }
    );
  };

  /*
   * 活动信息条按变体切换。
   * 需求方优化要求：若该产品全部变体命中同一条目，服务端会输出 static: true，这里直接不做任何事。
   */
  VLCard.prototype.renderInfo = function (variantId) {
    var data = this.infoData || {};
    if (data.static) return;

    var list = Array.isArray(data.byVariant) ? data.byVariant : [];
    /* 2026-10-29：按「组」取 —— 当前变体优先，其次组内其它变体（同一颜色可能对应多条变体） */
    var entry = this.pickGroupEntry(list, 'info', variantId);

    var existing = this.root.querySelector('[data-vl-product-card-info]');
    var stack = this.root.querySelector('[data-vl-product-card-info-stack]');
    var info = entry && entry.info;
    if (!info) {
      if (stack) stack.remove();
      else if (existing) existing.remove();
      return;
    }

    if (!stack) {
      var slot = this.root.querySelector('[data-vl-product-card-info-slot]');
      stack = document.createElement('div');
      stack.className = 'vl-product-card__info-stack';
      stack.setAttribute('data-vl-product-card-info-stack', '');
      (slot || this.root).appendChild(stack);
      if (existing) stack.appendChild(existing);
    }

    if (!existing) {
      /* 插入固定高度槽位；槽位本身始终存在，因此移除信息条也不会破坏等高对齐 */
      existing = document.createElement('div');
      existing.className = 'vl-product-card__info';
      existing.setAttribute('data-vl-product-card-info', '');
      stack.appendChild(existing);
    }

    existing.setAttribute('data-vl-product-card-info-id', info.id);
    existing.style.setProperty('--vl-product-card-info-bg', info.bg);
    existing.style.setProperty('--vl-product-card-info-color', info.color);
    existing.style.setProperty('--vl-product-card-info-icon-bg', info.iconBg);

    var align = String(info.align || 'left').toLowerCase();
    existing.setAttribute('data-vl-product-card-info-align', align);
    existing.className = 'vl-product-card__info vl-product-card__info--align-' + align;

    /* 2026-11-02：配图包一层 wrap（问号图标 + 原文文案都在里面），JS 同步 extra / msg */
    var extraWrap = stack.querySelector('[data-vl-product-card-info-extra-wrap]');
    var extra = stack.querySelector('[data-vl-product-card-info-extra]');
    /* 2026-11-04：无配图时的等高占位（同行对齐用），有配图时移除 */
    var extraPlaceholder = stack.querySelector('[data-vl-product-card-info-extra-placeholder]');
    if (info.extra) {
      if (extraPlaceholder) {
        extraPlaceholder.remove();
        extraPlaceholder = null;
      }
      if (!extraWrap) {
        extraWrap = document.createElement('div');
        extraWrap.className = 'vl-product-card__info-extra-wrap';
        extraWrap.setAttribute('data-vl-product-card-info-extra-wrap', '');
        stack.insertBefore(extraWrap, existing);
      }
      if (!extra) {
        extra = document.createElement('img');
        extra.className = 'vl-product-card__info-extra';
        extra.setAttribute('data-vl-product-card-info-extra', '');
        extra.width = 284;
        extra.height = 22;
        extra.loading = 'lazy';
        extra.alt = '';
        extraWrap.insertBefore(extra, extraWrap.firstChild);
      }
      extra.hidden = false;
      extra.setAttribute('src', info.extra);
      syncInfoMsg(extraWrap, info.msg, this.root);
    } else {
      if (extraWrap) extraWrap.remove();
      if (extra) extra.remove();
      if (!extraPlaceholder) {
        extraPlaceholder = document.createElement('div');
        extraPlaceholder.className = 'vl-product-card__info-extra-wrap is-placeholder';
        extraPlaceholder.setAttribute('data-vl-product-card-info-extra-placeholder', '');
        extraPlaceholder.setAttribute('aria-hidden', 'true');
        var spacer = document.createElement('span');
        spacer.className = 'vl-product-card__info-extra-spacer';
        extraPlaceholder.appendChild(spacer);
        stack.insertBefore(extraPlaceholder, existing);
      }
    }

    existing.textContent = '';
    var content = document.createElement('span');
    content.className = 'vl-product-card__info-content';
    if (info.icon) {
      var iconWrap = document.createElement('span');
      iconWrap.className = 'vl-product-card__info-icon';
      var img = document.createElement('img');
      img.src = info.icon;
      img.alt = '';
      img.width = 18;
      img.height = 18;
      img.loading = 'lazy';
      iconWrap.appendChild(img);
      content.appendChild(iconWrap);
    }
    var text = document.createElement('span');
    text.className = 'vl-product-card__info-text';
    text.setAttribute('data-vl-product-card-info-text', '');
    text.textContent = info.content;
    content.appendChild(text);
    existing.appendChild(content);

    this.setupInfoMarquee();
  };

  /*
   * 变体缺少 featured_image 的暴露（用户 2026-09-23 裁决：不做兜底，把问题暴露出来，
   * 才能回后台补齐该变体的图片）。DOM 上留 data-vl-product-card-image-state 便于 QA 定位，
   * 控制台报错带产品链接与变体 ID；后台补齐图片后两处都会自然消失。
   */
  VLCard.prototype.reportImageMissing = function (variantId) {
    this.root.setAttribute('data-vl-product-card-image-state', 'missing');
    console.error('[vl-product-card] 选中的变体没有图片，按裁决不做兜底（请在后台为该变体上传图片）', {
      product: this.root.getAttribute('data-product-url') || '',
      variantId: String(variantId == null ? '' : variantId)
    });
  };

  VLCard.prototype.clearImageMissing = function () {
    this.root.removeAttribute('data-vl-product-card-image-state');
  };

  VLCard.prototype.renderTag = function (variantId) {
    /* 标签相对卡片根定位（left/top 16px），不能挂在有 16px 外边距的媒体容器里 */
    var host = this.root;
    /* 2026-10-29：按「组」取 —— 当前变体优先，其次组内其它变体（同一颜色可能对应多条变体） */
    var entry = this.pickGroupEntry(this.tags, 'tag', variantId);
    var existing = host.querySelector('.vl-product-card__tag');
    var tag = entry && entry.tag;

    if (!tag) {
      if (existing) existing.remove();
      return;
    }

    if (!existing) {
      existing = document.createElement('span');
      existing.className = 'vl-product-tag vl-product-card__tag';
      host.appendChild(existing);
    }
    existing.textContent = tag.text;
    existing.style.setProperty('--vl-product-tag-bg', tag.bg);
    existing.style.setProperty('--vl-product-tag-color', tag.color);
    existing.style.setProperty('--vl-product-tag-border', tag.border);

    /* 标签角标图（2026-10-29）：有图 ⇒ 左侧出图并让出 28px 文字内边距；无图 ⇒ 移除图与修饰类 */
    var tagImage = existing.querySelector('.vl-product-tag__image');
    if (tag.image) {
      if (!tagImage) {
        tagImage = document.createElement('img');
        tagImage.className = 'vl-product-tag__image';
        tagImage.setAttribute('alt', '');
        tagImage.setAttribute('aria-hidden', 'true');
        tagImage.setAttribute('width', '48');
        tagImage.setAttribute('height', '48');
        tagImage.setAttribute('loading', 'lazy');
        existing.insertBefore(tagImage, existing.firstChild);
      }
      tagImage.setAttribute('src', tag.image);
      existing.classList.add('vl-product-tag--has-image');
    } else {
      if (tagImage) tagImage.remove();
      existing.classList.remove('vl-product-tag--has-image');
    }
  };

  /*
   * 库存警告按「组」切换（2026-10-29 用户）：
   * 组内任一变体带库存信息即展示，取组内**第一个带信息**的变体（当前变体优先）；
   * 无信息则移除该行，价格与 Affirm 自然贴合。
   */
  VLCard.prototype.renderInventory = function (variantId) {
    var list = Array.isArray(this.inventoryData) ? this.inventoryData : [];
    if (!list.length) return;
    var entry = this.pickGroupEntry(list, 'inventory', variantId);
    var inv = entry && entry.inventory;
    var el = this.root.querySelector('[data-vl-product-card-inventory]');

    if (!inv || !inv.info) {
      if (el) el.remove();
      return;
    }

    if (!el) {
      el = document.createElement('div');
      el.className = 'vl-product-card__inventory';
      el.setAttribute('data-vl-product-card-inventory', '');
      var block = this.root.querySelector('.vl-product-card__price-block');
      var affirmBar = block ? block.querySelector('[data-vl-product-card-affirm]') : null;
      if (block) block.insertBefore(el, affirmBar || null);
      else return;
      el.innerHTML = '<span class="vl-product-card__inventory-text"></span>';
    }

    var text = el.querySelector('.vl-product-card__inventory-text');
    if (text) text.textContent = inv.info;

    var pct = Number(inv.pct) || 0;
    if (pct > 0) {
      if (pct > 100) pct = 100;
      var track = el.querySelector('.vl-product-card__inventory-track');
      if (!track) {
        track = document.createElement('span');
        track.className = 'vl-product-card__inventory-track';
        track.setAttribute('aria-hidden', 'true');
        var fill = document.createElement('span');
        fill.className = 'vl-product-card__inventory-fill';
        track.appendChild(fill);
        el.appendChild(track);
      }
      var bar = track.querySelector('.vl-product-card__inventory-fill');
      if (bar) bar.style.width = pct + '%';
    } else {
      var existingTrack = el.querySelector('.vl-product-card__inventory-track');
      if (existingTrack) existingTrack.remove();
    }
  };

  /*
   * 赠品角标按变体切换（数据源：用户 2026-09-28 裁决的 vl_product_free_gift）。
   * 与信息条一致：全部变体命中同一条目时服务端输出 static: true，这里直接不做任何事。
   * 角标是卡片根的直接子元素（定位基准＝**整个产品卡** top/right 20px，用户 2026-09-28 裁决），
   * 与左上角标签 `renderTag` 同层，因此宿主是 this.root。
   */
  VLCard.prototype.renderGift = function (variantId) {
    var data = this.giftData || {};
    if (data.static) return;

    var list = Array.isArray(data.byVariant) ? data.byVariant : [];
    /* 2026-10-29：按「组」取 —— 产品维度的 `velotric.for_bike_variants` 本身按组匹配，
       同一颜色下的多条变体应共用同一结果；当前变体优先，其次组内其它变体。 */
    var entry = this.pickGroupEntry(list, 'gift', variantId);

    var existing = this.root.querySelector('[data-vl-product-card-gift]');
    var gift = entry && entry.gift;

    if (!gift) {
      if (existing) existing.remove();
      return;
    }

    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'vl-product-card__gift';
      existing.setAttribute('data-vl-product-card-gift', '');
      this.root.appendChild(existing);
    }

    existing.setAttribute('data-vl-product-card-gift-id', gift.id);
    existing.style.setProperty('--vl-pc-gift-bg', gift.bg || '#fffaed');
    existing.style.setProperty('--vl-pc-gift-border', gift.border || '#fede81');
    existing.style.setProperty('--vl-pc-gift-font', gift.color || '#1f1f1f');
    existing.setAttribute('data-gift-count', String(Math.min(Number(gift.count || (gift.images || []).length || 0), 4)));
    existing.setAttribute('data-gift-border-mode', gift.borderImage ? 'image' : 'color');

    var border = existing.querySelector('.vl-product-card__gift-border');
    if (gift.borderImage) {
      if (!border) {
        border = document.createElement('img');
        border.className = 'vl-product-card__gift-border';
        border.width = 54;
        border.height = 74;
        border.alt = '';
        border.loading = 'lazy';
        border.setAttribute('aria-hidden', 'true');
        existing.appendChild(border);
      }
      border.setAttribute('src', gift.borderImage);
    } else if (border) {
      border.remove();
    }

    var title = existing.querySelector('.vl-product-card__gift-title');
    if (gift.title) {
      if (!title) {
        title = document.createElement('span');
        title.className = 'vl-product-card__gift-title';
        existing.appendChild(title);
      }
      title.textContent = gift.title;
    } else if (title) {
      title.remove();
    }

    var media = existing.querySelector('.vl-product-card__gift-media');
    if (!media) {
      media = document.createElement('div');
      media.className = 'vl-product-card__gift-media';
      existing.appendChild(media);
    }

    /*
     * 角标图：展示列表里的**全部**项（用户 2026-09-28 裁决 P-1，不再只取 1 个）。
     * `gift.images` 为 [{src, src2x}]；为兼容旧数据仍支持单个 `gift.image`。
     */
    var images = Array.isArray(gift.images) ? gift.images : [];
    if (!images.length && gift.image) {
      images = [{ src: gift.image, src2x: gift.image2x }];
    }
    Array.prototype.forEach.call(existing.querySelectorAll('.vl-product-card__gift-image, .vl-product-card__gift-plus'), function (node) {
      node.remove();
    });
    var count = Math.min(images.length, 4);
    existing.setAttribute('data-gift-count', String(count));
    images.slice(0, count).forEach(function (entry) {
      if (!entry || !entry.src) return;
      var image = document.createElement('img');
      image.className = 'vl-product-card__gift-image';
      image.width = count === 1 ? 48 : (count === 2 ? 32 : 28);
      image.height = image.width;
      image.alt = '';
      image.loading = 'lazy';
      image.setAttribute('src', entry.src);
      if (entry.src2x) image.setAttribute('srcset', entry.src + ' 1x, ' + entry.src2x + ' 2x');
      media.appendChild(image);
    });
    if (count > 1) {
      var plus = document.createElement('span');
      plus.className = 'vl-product-card__gift-plus';
      plus.textContent = '+';
      plus.setAttribute('aria-hidden', 'true');
      media.appendChild(plus);
    }
  };

  /*
   * 依据当前 Style 刷新色块可用态与选中态。
   * 2026-10-20 方案 B：只看当前 Style——该颜色在当前 Style 下没有可售变体就隐藏/禁用；
   * 切到有货的 Style 后重新显示。无 Style 时按该颜色全局是否有可售变体判断。
   */
  VLCard.prototype.syncColorStates = function () {
    if (!this.colorInputs.length) return;
    var self = this;
    this.colorInputs.forEach(function (input) {
      var label = input.closest('.vl-product-card__swatch');
      var available = self.hasStyle
        ? self.colorAvailableForStyle(input.value, self.selected.style)
        : self.colorAvailable(input.value);
      if (label) label.classList.toggle('is-unavailable', !available);
      input.disabled = !available;
      /*
       * 色块行只展示「当前 Style 下至少有一个可售变体的颜色」（用户 2026-10-20 方案 B）。
       * 首屏由 snippets/vl-product-card.liquid 的 `:has` 规则负责，这里是与它等价的兜底（覆盖不支持 :has 的浏览器）。
       */
      if (label) label.hidden = !available;
      var isSelected = sameValue(input.value, self.selected.color);
      input.checked = isSelected;
      if (label) label.classList.toggle('is-selected', isSelected);
    });
  };

  VLCard.prototype.onStyleChange = function (value) {
    var previous = this.selected.style;
    var previousColor = this.selected.color;
    this.selected.style = value;
    if (this.hasColor && !this.colorAvailableForStyle(this.selected.color, value)) {
      var next = this.firstColorOfStyle(value);
      if (next) this.selected.color = next;
    }
    /*
     * 2026-11-03：选项值可能已经没有可选变体（例如 GoMad 的 Package 被隐藏/下架）。
     * 此时不进入渲染，回退到上一个值，避免出现「select 值变了、卡面没变」的死状态。
     */
    if (!this.findVariant(this.selected)) {
      this.selected.style = previous;
      this.selected.color = previousColor;
      if (this.styleSelect) this.styleSelect.value = previous;
      this.syncOptionPills();
      return;
    }
    this.render();
  };

  /* 按颜色值的原始顺序取该 Style 下第一个可售颜色；全售罄时回落到第一个存在的颜色 */
  VLCard.prototype.firstColorOfStyle = function (style) {
    if (!this.hasColor) return null;
    var self = this;
    var ordered = this.colorInputs.length
      ? this.colorInputs.map(function (input) { return input.value; })
      : this.colors;
    for (var i = 0; i < ordered.length; i += 1) {
      if (self.colorAvailableForStyle(ordered[i], style)) return ordered[i];
    }
    for (var j = 0; j < ordered.length; j += 1) {
      if (self.colorExistsForStyle(ordered[j], style)) return ordered[j];
    }
    return ordered[0] || null;
  };

  VLCard.prototype.bind = function () {
    var self = this;
    if (this.hasStyle && this.styleSelect) {
      this.styleSelect.addEventListener('change', function (event) {
        self.onStyleChange(event.target.value);
      });
    }
    this.colorInputs.forEach(function (input) {
      input.addEventListener('change', function (event) {
        if (!event.target.checked) return;
        var color = event.target.value;
        /*
         * 该颜色在当前 Style 下没有变体时，自动把 Style 切到它存在的那个 Style
         * （否则点了色块也没有可渲染的变体 → 表现为"点了没反应"）。
         */
        if (self.hasStyle && self.styleSelect && !self.colorExistsForStyle(color, self.selected.style)) {
          var targetStyle = self.firstStyleOfColor(color);
          if (targetStyle) {
            self.styleSelect.value = targetStyle;
            self.selected.style = targetStyle;
          }
        }
        self.selected.color = color;
        self.render();
      });
    });
    this.bindOptionPills();
    this.syncColorStates();
    this.syncOptionPills();

    /*
     * 首屏暴露：预选变体没有图片时 Liquid 侧不渲染 <img>（同样不做兜底），
     * 这里显式报出来，避免只表现为"画廊空白"而无人察觉（用户 2026-09-23 裁决）。
     */
    if (!this.root.querySelector('[data-vl-product-card-image]')) this.reportImageMissing(null);

    /* 首屏也要初始化跑马灯（此前误插到 render() 内，导致首屏从未执行） */
    this.setupInfoMarquee();
  };

  /*
   * 2026-10-30：同页可能出现同一产品的多张卡（如 BF 列表），Liquid 的 radio name 只用 product.id
   * ⇒ 浏览器把它们当成同一个单选组，后渲染的卡会把前一张的 checked 顶掉（默认色失去选中态）。
   * 初始化时给每张卡的色块单选组追加唯一后缀，保证互不干扰。
   */
  var colorGroupSeq = 0;

  function uniquifyColorGroup(root) {
    colorGroupSeq += 1;
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-vl-product-card-color]'));
    if (!inputs.length) return;
    var base = inputs[0].name;
    if (!base || base.indexOf('-card') !== -1) return;

    /*
     * 2026-11-02 修复：改 name 之前浏览器已按「同名单选组」处理过 —— 同页后渲染的同产品卡
     * 会把前一张卡的 checked **属性**顶掉（DOM 里已无选中项），此时 readSelectedFromDOM()
     * 只能回落到「该 Style 的第一个颜色」，表现为"默认选中的永远是第一个色"。
     * `defaultChecked` 读的是 HTML 的 checked 属性，不受分组影响，用它把默认选中补回来。
     */
    var hasChecked = inputs.some(function (input) { return input.checked; });
    inputs.forEach(function (input) { input.name = base + '-card' + colorGroupSeq; });
    if (!hasChecked) {
      var fallback = inputs.filter(function (input) { return input.defaultChecked; })[0];
      if (fallback) fallback.checked = true;
    }
  }

  function init() {
    var roots = document.querySelectorAll('vl-product-card[data-vl-product-card]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.vlProductCardReady === 'true') return;
      root.dataset.vlProductCardReady = 'true';
      uniquifyColorGroup(root);
      var card = new VLCard(root);
      card.bind();

      /*
       * 跑马灯判定依赖「文本实际宽度」，因此必须在字体就绪后重新判定一次：
       * bind() 执行时 Web 字体往往尚未加载，回退字体偏窄会误判为「放得下」。
       */
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          card.setupInfoMarquee();
          /* 字体换完后胶囊宽度才稳定，重新定位选中项（2026-11-03） */
          card.syncOptionPills();
        });
      }

      /*
       * 字体真正换上的时刻与 fonts.ready 不一定一致：回退字体比 Manrope 宽时会先判成"放不下"，
       * 于是时长按更宽的距离算出来，等字体换完、实际距离变小后，速度就与约定的 30px/s 不符
       * （实测 1440 视口：算出的 9.53s 对应 285.9px 距离，而实际距离只有 280.5px → 29.43px/s）。
       * 因此再监听 fonts 的 loadingdone，字体换完后重新判定一次：放得下恢复静止、放不下按新距离重算时长。
       */
      if (document.fonts && document.fonts.addEventListener) {
        document.fonts.addEventListener('loadingdone', function () {
          card.setupInfoMarquee();
        });
      }

      /* 卡片宽度随视口/列数变化时重新判定（用宽度守卫避免观察-改DOM 的循环） */
      if (window.ResizeObserver) {
        var lastWidth = root.clientWidth;
        var observer = new ResizeObserver(function () {
          if (root.clientWidth === lastWidth) return;
          lastWidth = root.clientWidth;
          card.setupInfoMarquee();
        });
        observer.observe(root);
      }
    });
  }

  /*
   * 集合页的筛选/排序是 AJAX 替换（主题 bundle.js 的 ShopComponent.updateContent
   * 用 fetch 取回整段，再 replaceNodeChildren 换掉 #ShopProducts 的子节点），
   * 既不会重新执行本脚本，也不触发 shopify:section:load ⇒ 换进来的新卡片无人初始化
   * （实测：点一次价格筛选，14 张卡 → 1 张卡，ready 标记 0）。
   *
   * 修法：观察 #ShopProducts 的子节点替换，发现「有未初始化的卡片」时再跑一次 init()；
   * init() 本身按 data-vl-product-card-ready 幂等，不会重复绑定。
   * 只在确实存在未初始化卡片时才继续，避免 init() 内部改动 DOM 造成观察-初始化的循环。
   */
  var reinitTimer = null;

  function hasUninitializedCard() {
    return !!document.querySelector('vl-product-card[data-vl-product-card]:not([data-vl-product-card-ready="true"])');
  }

  function queueReinit() {
    if (reinitTimer) window.clearTimeout(reinitTimer);
    reinitTimer = window.setTimeout(function () {
      reinitTimer = null;
      if (!hasUninitializedCard()) return;
      init();
      /* 通知同页的排版脚本（标题带按行对齐 / 内容上提）重新测量 */
      document.dispatchEvent(new CustomEvent('vl-collection:cards-updated'));
    }, 80);
  }

  function observeProductList() {
    if (!window.MutationObserver) return;
    var list = document.getElementById('ShopProducts') || document.querySelector('.shop__products-grid-wrap');
    if (!list || list.dataset.vlProductCardObserved === 'true') return;
    list.dataset.vlProductCardObserved = 'true';
    new MutationObserver(queueReinit).observe(list, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeProductList, { once: true });
  } else {
    observeProductList();
  }
  /* 主题编辑器里 section 重载会换掉 #ShopProducts 本身 ⇒ 重新挂观察 */
  document.addEventListener('shopify:section:load', function () {
    observeProductList();
    queueReinit();
  });
})();
